import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { WPConfig, HubPageACF, HubPageWPConfig } from '../../../shared/interfaces';
import { DOCUMENT } from '@angular/common';
import { Store } from '@ngrx/store';
import * as ngrxTypes from '../../store/root.types';
import { filter } from 'rxjs/operators';

/**
 * Handles adding classes to the body
 * This is used to apply the ad campaign & simplified selector styles to components
 */
@Injectable()
export class BodyClassesService {
  classes: string[] = [];
  renderer: Renderer2;

  constructor(
    rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document,
    private store: Store<ngrxTypes.AppState>,
  ) {
    this.renderer = rendererFactory.createRenderer(this.document, null);
  }

  /**
   * Works out which classes to add to the body based on the wordpress config file
   * todo: there may be some other classes it could be useful to add like post id, etc.
   */
  addClassesFromPageConfig(config: WPConfig) {
    this.removeClasses();

    // add "simplified-selector" class to body to indicate we should use the simplified selector
    // styling for the selector widget
    if (
      config.acf &&
      ((<HubPageACF>config.acf).selector_builder === 'cutdown' || (<HubPageACF>config.acf).home_page === true)
    ) {
      this.addClass('simplified-selector');
    } else if (config.type === 'comparisons' || config.type === 'post') {
      this.store
        .select(ngrxTypes.primaryCategory)
        .pipe(filter((categoryConfig) => categoryConfig !== null))
        .subscribe((categoryConfig: HubPageWPConfig) => {
          if ((<HubPageACF>categoryConfig.acf).selector_builder === 'cutdown') {
            this.addClass('simplified-selector');
          }
        });
    }

    // add .ad-campaign class to body to indicate hub page needs to use the new styling
    // introduced for the June 2017 ad campaign
    if (config.acf && (<HubPageACF>config.acf).ad_campaign_styling === true) {
      this.addClass('ad-campaign');
    }
  }

  /**
   * @description Remove a specific class from the body.
   * @param className @type {string} - Class to be removed from body.
   */
  removeClass(className: string) {
    const index = this.classes.indexOf(className);
    if (index > -1) {
      // only splice array when item is found
      this.classes.splice(index, 1); // 2nd parameter means remove one item only
    }
    this.renderer.removeClass(this.document.body, className);
  }

  addClass(className: string) {
    this.classes.push(className);
    this.renderer.addClass(this.document.body, className);
  }

  private removeClasses() {
    this.classes.forEach((className) => this.renderer.removeClass(this.document.body, className));
    this.classes = [];
  }
}
